import React from 'react';
// import { Helmet } from 'react-helmet-async'; // Import Helmet for meta tags
import Hero2 from '../components/Hero/Hero2';


import HomeLearnMore from '../components/HomeLearnMore';
import ManufacturingProcess from '../components/ManufacturingProcess';
import SEO from '../components/SEO';


// import FeaturedCarByType from '../components/ProductCard/FeaturedCarByType';

function Home() {
  return (
    <div className=" bg-white">
      
     
      <SEO
        title="Premium Export Quality Boxing Equipment Manufacturer | IES Gear"
        description="IES Gear manufactures premium boxing gloves, MMA gear, punching bags, sportswear, and custom fight equipment for gyms, brands, and wholesalers worldwide."
        keywords="boxing equipment manufacturer, custom boxing gloves, MMA gear supplier, boxing gear wholesale, punching bags manufacturer, sportswear manufacturer"
        url="https://iesgear.com/"
      />

      {/* Page Content */}
      <Hero2 />
      {/* <FeaturedProduct /> */}
       {/* <SUVLovers/> */}
       
       <ManufacturingProcess/>
      {/* <SportsLovers/>  */}
      <HomeLearnMore/>
      
      
      {/* <BrandCategory /> */}
      
    </div>
  );
}

export default Home;
